import {
  CheckListIcon,
  FilesIcon,
  GlossaryIcon,
  NotesIcon,
  PhaseIcon,
  PluginIcon,
  PluginListIcon,
  TaskIcon,
  TutorialIcon,
} from "allIcons";
import { compact } from "helpers";

export default function libraryMenu(siteTemplate) {
  const menu = [
    {
      title: "templateLibrary.menu.tasks",
      module: "tasks",
      icon: <TaskIcon />,
    },
    {
      title: "templateLibrary.menu.checklists",
      module: "checklists",
      icon: <CheckListIcon />,
    },
    {
      title: "templateLibrary.menu.notes",
      module: "notes",
      icon: <NotesIcon />,
    },
    !siteTemplate && {
      title: "templateLibrary.menu.phases",
      module: "phases",
      icon: <PhaseIcon />,
    },
    {
      title: "templateLibrary.menu.glossary",
      module: "glossary",
      icon: <GlossaryIcon />,
    },
    {
      title: "templateLibrary.menu.tutorials",
      module: "tutorials",
      icon: <TutorialIcon />,
    },
    // Here for future use
    // {
    //   title: "Courses",
    //   module: "templateLibrary.menu.courses",
    //   icon: <CourseIcon />,
    // },
    {
      title: "templateLibrary.menu.contentRequests",
      module: "content-request-templates",
      icon: <FilesIcon />,
    },
    !siteTemplate && {
      title: "templateLibrary.menu.contentRequestItems",
      module: "content-request-items",
      icon: <FilesIcon />,
    },
    // Here for future use
    // {
    //   title: "templateLibrary.menu.services",
    //   module: "services",
    //   icon: <ServiceIcon />,
    // },
    // {
    //   title: "templateLibrary.menu.proposals",
    //   module: "proposals",
    //   icon: <ProposalIcon />,
    // },
    // {
    //   title: "templateLibrary.menu.contracts",
    //   module: "contract-template",
    //   icon: <ContractIcon />,
    // },
    // {
    //   title: "templateLibrary.menu.forms",
    //   module: "forms",
    //   icon: <FormTemplateIcon />,
    // },
    // {
    //   title: "templateLibrary.menu.formSections",
    //   module: "form-sections",
    //   icon: <FormSectionIcon />,
    // },
    // {
    //   title: "templateLibrary.menu.formFields",
    //   module: "form-fields",
    //   icon: <FormFieldIcon />,
    // },
    // {
    //   title: "templateLibrary.menu.formFieldOptions",
    //   module: "form-field-options",
    //   icon: <FormFieldOptionIcon />,
    // },
    // {
    //   title: "templateLibrary.menu.screenRecordings",
    //   module: "screen-recordings",
    //   icon: <ScreenRecordingIcon />,
    // },
    !siteTemplate && {
      title: "templateLibrary.menu.plugins",
      module: "plugins",
      icon: <PluginIcon />,
    },
    !siteTemplate && {
      title: "templateLibrary.menu.pluginLists",
      module: "plugin-lists",
      icon: <PluginListIcon />,
    },
  ];
  return compact(menu);
}
